var exports = {
  "uK": "GiftPlutoniumModal.module__option___czBfMG",
  "fS": "GiftPlutoniumModal.module__optionName___czBfMG",
  "$f": "GiftPlutoniumModal.module__optionPrice___czBfMG",
  "qS": "GiftPlutoniumModal.module__badge___czBfMG",
  "N4": "GiftPlutoniumModal.module__note___czBfMG",
};

module.exports = exports;
